import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import store from "./redux/store";
import registerServiceWorker from "./registerServiceWorker";
import { setOneSignalInfo } from "./helpers/Utils";
import "typeface-roboto";

// Setting the OneSignal info to local storage when using the mobile app.
window.gonative_onesignal_info = (oneSignalInfo) =>
  setOneSignalInfo(oneSignalInfo);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Route path="/" component={App} />
    </Router>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js